const hasPermission = (list: string[], str: string) => {
  const isPermissions = list.filter((el) => el.startsWith(str));
  return isPermissions.length > 0;
};

const strFormatNumber = (str: string, isNegative = false) => {
  const strs = str.split(".");
  let n = Number(strs[0]);
  if (isNaN(n)) return str;
  n = isNegative && n !== 0 ? -n : n;
  // 将数字转为本地字符串，并指定千分位分隔符为逗号
  let resutStr = n.toLocaleString("en-US");
  return strs.length > 1 ? `${resutStr}.${strs[1]}` : resutStr;
};

const downloadFile = (fileUrl: string, fileName: string) => {
  // const blob = new Blob(content) // 构造一个blob对象来处理数据
  // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
  // IE10以上支持blob但是依然不支持download
  if ("download" in document.createElement("a")) {
    // 支持a标签download的浏览器
    const link = document.createElement("a"); // 创建a标签
    link.download = fileName; // a标签添加属性
    link.style.display = "none";
    link.href = fileUrl;
    document.body.appendChild(link);
    link.click(); // 执行下载
    URL.revokeObjectURL(link.href); // 释放url
    document.body.removeChild(link); // 释放标签
  }
};

export { hasPermission, strFormatNumber, downloadFile };
